import React from 'react';

import { Box, Flex } from '../Core';
import { JustifyProps } from '../Core/utils';
import SectionContainer from '../SectionContainer';
import Text from '../Text';
import { TEXT_STYLES } from '../Text/constants';

interface ISectionWithTitleProps {
  contentAlignment?: JustifyProps;
  heading?: string | null;
  headingTag?: 'h1' | 'h2' | 'h3';
  text?: string | null;
  id?: string;
  style?: React.CSSProperties;
}

const SectionWithTitle: FCWithClassName<ISectionWithTitleProps> = (props) => {
  const { children, contentAlignment, heading, text, id, ...rest } = props;
  return (
    <SectionContainer className="w-full mx-auto max-w-screen-xxl xxl:w-4/5" {...rest} id={id}>
      <Flex className="section-content" align="center" direction="column">
        {heading && (
          <Flex
            align="center"
            direction="column"
            className="z-10 mb-16 text-center h-m title"
          >
            <Text variant={TEXT_STYLES.SECTION} as={props.headingTag} >{heading}</Text>
            {text && (
              <Box>
                <Text variant={TEXT_STYLES.H5} className="mt-4">
                  {text}
                </Text>
              </Box>
            )}
          </Flex>
        )}
        <Flex
          className="flex-wrap w-full content max-w-screen-xxl"
          justify={contentAlignment ?? 'flex-start'}
        >
          {children}
        </Flex>
      </Flex>
    </SectionContainer>
  );
};

export default SectionWithTitle;
